var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackBtnJoinedGiveaways(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.168 10.0002C19.168 15.0628 15.0639 19.1668 10.0013 19.1668C4.93869 19.1668 0.834632 15.0628 0.834632 10.0002C0.834633 4.93755 4.93869 0.833495 10.0013 0.833496C15.0639 0.833496 19.168 4.93755 19.168 10.0002ZM17.793 10.0002C17.793 5.69694 14.3045 2.2085 10.0013 2.2085C5.69808 2.2085 2.20963 5.69694 2.20963 10.0002C2.20963 14.3034 5.69808 17.7918 10.0013 17.7918C14.3045 17.7918 17.793 14.3034 17.793 10.0002ZM11.8624 5.84736C12.1309 6.11585 12.1309 6.55115 11.8624 6.81963L8.68191 10.0002L11.8624 13.1807C12.1309 13.4492 12.1309 13.8845 11.8624 14.153C11.594 14.4215 11.1586 14.4215 10.8902 14.153L7.2235 10.4863C6.95501 10.2178 6.95501 9.78251 7.2235 9.51403L10.8902 5.84736C11.1587 5.57888 11.594 5.57888 11.8624 5.84736Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtnJoinedGiveaways);
export default __webpack_public_path__ + "static/media/back-btn-joined-giveaways.1961b448b92652f77db86c6962f60894.svg";
export { ForwardRef as ReactComponent };